/* eslint-disable no-undef */
module.exports = {
  cpf: {
    path: '/cpf',
    component: `src/pages/LandingCpf/index.js`,
  },

  register: {
    path: '/registro',
    component: `src/pages/LandingRegister/index.js`,
  },

  noDebt: {
    path: '/semDivida',
    component: `src/pages/NoDebt/index.js`,
  },

  reneg: {
    path: '/renegociacao-itau',
    component: `src/pages/Reneg/index.js`,
  },

  captcha: {
    path: '/captcha',
    component: `src/pages/Captcha/index.js`,
  },

  steps: {
    path: '/steps',
    component: `src/pages/Steps/index.js`,
  },

  error: {
    path: '/error',
    component: `src/pages/Error/index.js`,
  },

  seviceUnavailable: {
    path: '/service-unavailable',
    component: `src/pages/Error/components/404/index.js`,
  },

  unsubscribe: {
    path: '/desinscrever',
    component: `src/pages/Unsubscribe/index.js`,
  },
  skipper: {
    path: `/skipper`,
    component: `src/pages/Skipper/index.js`,
  },
  notFound: {
    path: `/pagina-nao-encontrada`,
    component: `src/pages/NotFound/index.js`,
  },
}
